import "@/App.css";
import "@/OpsDashboard.css";
import "@/OpsB2bPage.css";
import "@/AuthModal.css";
import "@/AyaHeader.css";
import "@/components/AyaNotch.css";
import { useEffect, useState, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import InstallPrompt from "@/pwa/InstallPrompt";
import Chat from "@/components/Chat";
import OpsDashboard from "@/components/OpsDashboard";
import OpsB2bPage from "@/pages/OpsB2bPage";
import PublicCoverageMap from "@/pages/PublicCoverageMap";
import MapExplorerPage from "@/pages/MapExplorerPage";
import AyaSplash from "@/components/AyaSplash";
import OnboardingGate from "@/components/OnboardingGate";
import AddressingPage from "@/pages/AddressingPage";
import DeliveryPage from "@/pages/DeliveryPage";
import GpsCourierPage from "@/pages/GpsCourierPage";
import DeliveryRedirect from "@/pages/DeliveryRedirect";
import MonComptePage from "@/pages/MonComptePage";
import LiveDashboardPage from "@/pages/LiveDashboardPage";
import OpsLiveRoomPage from "@/pages/OpsLiveRoomPage";
import LiveOverlayPage from "@/pages/LiveOverlayPage";
import LiveLandingPage from "@/pages/LiveLandingPage";import ProOnboardingPage from "@/pages/ProOnboardingPage";
import AyaProStartPage from "@/pages/ayapro/AyaProStartPage";
import AyaProSignupPage from "@/pages/ayapro/AyaProSignupPage";
import AyaProLoginPage from "@/pages/ayapro/AyaProLoginPage";
import AyaProActivatePage from "@/pages/ayapro/AyaProActivatePage";
import AyaProDashboardPage from "@/pages/ayapro/AyaProDashboardPage";
import BoutiquePage from "@/pages/ayapro/BoutiquePage";
import PersonnalitePage from "@/pages/persona/PersonnalitePage";
import MairiePage from "@/pages/geo/MairiePage";
import MultiservicePage from "@/multiservice/MultiservicePage";
import MultiserviceHistoryPage from "@/multiservice/MultiserviceHistoryPage";
import PersonalityStudioPage from "@/internal/PersonalityStudioPage";
import FichesStudioPage from "@/internal/FichesStudioPage";
import OpsInscriptionsProPage from "@/pages/OpsInscriptionsProPage";
import OpsImpressionsPage from "@/pages/OpsImpressionsPage";
import OpsDigestsPage from "@/pages/OpsDigestsPage";
import PartnerConsolePage from "@/pages/PartnerConsolePage";
import AddressRequestLandingPage from "@/pages/AddressRequestLandingPage";
import EventPublicPage from "@/pages/EventPublicPage";
import JobDetailPage from "@/pages/JobDetailPage";
import DirectoryDetailPage from "@/pages/DirectoryDetailPage";
import CabinetPage from "@/pages/CabinetPage";
import CabinetVisioPage from "@/pages/CabinetVisioPage";
import CabinetDossierPage from "@/pages/CabinetDossierPage";
import CabinetAdminPage from "@/pages/CabinetAdminPage";
import CourierLoginPage from "@/pages/CourierLoginPage";
import MediaHubPage from "@/pages/MediaHubPage";
import KiosqueCatalogsPage from "@/pages/KiosqueCatalogsPage";
import CatalogDetailPage from "@/pages/CatalogDetailPage";
import KiosqueSectionPage from "@/pages/KiosqueSectionPage";
import MerchantCatalogsPage from "@/pages/MerchantCatalogsPage";
import FamilyBasketPage from "@/pages/FamilyBasketPage";
import DiasporaDashboardPage from "@/pages/DiasporaDashboardPage";
import MiniSitePage from "@/pages/MiniSitePage";
import CourierNavigatePage from "@/pages/CourierNavigatePage";
import CourierHistoriquePage from "@/pages/CourierHistoriquePage";
import CourierHeatmapPage from "@/pages/CourierHeatmapPage";
import SearchPage from "@/pages/SearchPage";
import BrvmPage from "@/pages/BrvmPage";
import LegalPage from "@/pages/LegalPage";
import CommandCenterPage from "@/internal/CommandCenterPage";
import OperationsPage from "@/internal/OperationsPage";
import ProValidationPage from "@/internal/ProValidationPage";
import AuditLogPage from "@/internal/AuditLogPage";
import WorkspacesPage from "@/internal/WorkspacesPage";
import WorkspacePage from "@/internal/WorkspacePage";
import ApprovalsPage from "@/internal/ApprovalsPage";
import KnowledgePage from "@/internal/KnowledgePage";
import AgentsPage from "@/internal/AgentsPage";
import SecurityPage from "@/internal/SecurityPage";
import SecureWelcomePage from "@/internal/SecureWelcomePage";
import StudioPage from "@/internal/studio/StudioPage";
import TechStudioPage from "@/internal/studio/TechStudioPage";
import ProductStudioPage from "@/internal/studio/ProductStudioPage";
import SavedPage from "@/pages/SavedPage";
import SearchDetailPage from "@/pages/SearchDetailPage";
import FounderLoginPage from "@/pages/FounderLoginPage";
import FounderOnboardingPage from "@/pages/FounderOnboardingPage";
import FounderDashboardPage from "@/pages/FounderDashboardPage";
import VerifyReceiptPage from "@/pages/VerifyReceiptPage";
import CommercePage from "@/pages/CommercePage";
import ServicesPublicsPage from "@/pages/ServicesPublicsPage";
import ServicesPage from "@/pages/ServicesPage";
import BienEtrePage from "@/pages/BienEtrePage";
import ProProfilePage from "@/pages/ProProfilePage";
import LocationPage from "@/pages/LocationPage";
import BienDetailPage from "@/pages/BienDetailPage";
import TransportProPage from "@/pages/TransportProPage";
import SantePage from "@/pages/SantePage";
import FlightBookingPage from "@/transport/FlightBookingPage";
import BusBookingPage from "@/transport/BusBookingPage";
import TaxiBookingPage from "@/transport/TaxiBookingPage";
import ChauffeurPrivePage from "@/transport/ChauffeurPrivePage";
import MesBilletsPage from "@/transport/MesBilletsPage";
import ExperiencesPage from "@/experiences/ExperiencesPage";
import SolidaritePage from "@/experiences/SolidaritePage";
import AcademyPage from "@/experiences/AcademyPage";
import TransportHubPage from "@/transport/TransportHubPage";
import ChauffeurPage from "@/chauffeur/ChauffeurPage";
import SharedAddressPage from "@/pages/SharedAddressPage";
import OpsCommandesPage from "@/pages/OpsCommandesPage";
import TrackOrderPage from "@/pages/TrackOrderPage";
import ReplayPage from "@/pages/ReplayPage";
import CourierArrivalPage from "@/pages/CourierArrivalPage";
// v2.19.39-sec1 — Auth wall + page /login dédiée.
import RequireAuth from "@/components/RequireAuth";
import LoginPage from "@/pages/LoginPage";
import AuthInterceptor from "@/components/AuthInterceptor";
// AYA PRO Phase 1 — page de choix d'espace + espace pro dédié.
import SpaceChoicePage from "@/pages/SpaceChoicePage";
import ProAccessPage from "@/pages/ProAccessPage";
import SpaceGate from "@/components/SpaceGate";
import AyaProHomePage from "@/pages/AyaProHomePage";
import FiscalCenterPage from "@/pages/FiscalCenterPage";
import ProCategoryPage from "@/pages/ProCategoryPage";
import ProAssistantPage from "@/pages/ProAssistantPage";
import ProComptePage from "@/pages/ProComptePage";
import DeskPage from "@/pages/DeskPage";
import ProTaxesPage from "@/pages/ProTaxesPage";
// v3.0.0-rc.4 — Phase 5.b.4 : Governance Dashboard (owner-only, layout autonome).
import GovernancePage from "@/pages/GovernancePage";
const RXPreviewPage = lazy(() => import("@/pages/RXPreviewPage"));
// v3.0.0-rc.7-phaseCD — Phase C.2 : Wallet B2C utilisateur final (palette vert émeraude + gold).
import WalletB2cPage from "@/components/WalletB2cPage";
// v4.11.0 — Mini-site unifié (remplace MerchantPage + PlaceSitePage).
// [SPRINT K P1] Services prestataires (public, mock).
import ServiceProviderPage from "@/pages/ServiceProviderPage";
// [H_UIPOLISH_V1_L3 sous-palier 2.B] Wrap racine polish-only : LazyMotion + ToastProvider.
import { LazyMotion, domAnimation } from "framer-motion";
import { AyaToastProvider } from "@/components/ui/Toast";

function App() {
  // v2.19.22g — Splash screen au boot.
  // v2.19.28 — Augmenté à 3s pour laisser passer 1 tour complet du masque (rotation 6s → demi-tour visible).
  // v4.5.0 — Pas de splash sur l'overlay Live (source navigateur OBS, fond transparent).
  const _isOverlayRoute = typeof window !== "undefined" && (window.location.pathname.startsWith("/live/overlay/") || window.location.pathname.startsWith("/founder"));
  const [splashVisible, setSplashVisible] = useState(!_isOverlayRoute);
  useEffect(() => {
    const t = setTimeout(() => setSplashVisible(false), 3000);
    return () => clearTimeout(t);
  }, []);

  return (
    <LazyMotion features={domAnimation} strict>
    <AyaToastProvider>
    <div className="App">
      <AyaSplash visible={splashVisible} />
      <AuthInterceptor />
      <OnboardingGate />
      <Toaster position="top-center" richColors closeButton />
      <InstallPrompt />
      <BrowserRouter>
        <Routes>
          {/* 2026-09 — Architecture ayaai.africa : / = future Home (redirect temporaire → /search),
              /search = AYA Search, /aya-prive = espace conversationnel (Conversation Engine existant). */}
          <Route path="/" element={<Navigate to="/search" replace />} />
          <Route path="/brvm" element={<BrvmPage />} />
          <Route path="/internal" element={<CommandCenterPage />} />
          <Route path="/internal/workspaces" element={<WorkspacesPage />} />
          <Route path="/internal/ws/:slug" element={<WorkspacePage />} />
          <Route path="/internal/approvals" element={<ApprovalsPage />} />
          <Route path="/internal/knowledge" element={<KnowledgePage />} />
          <Route path="/internal/personnalites" element={<PersonalityStudioPage />} />
          <Route path="/internal/fiches" element={<FichesStudioPage />} />
          <Route path="/internal/agents" element={<AgentsPage />} />
          <Route path="/internal/security" element={<SecurityPage />} />
          <Route path="/internal/creator" element={<StudioPage />} />
          <Route path="/internal/tech-studio" element={<TechStudioPage />} />
          <Route path="/internal/product-studio" element={<ProductStudioPage />} />
          <Route path="/welcome" element={<SecureWelcomePage />} />
          <Route path="/internal/operations" element={<OperationsPage />} />
          <Route path="/internal/operations/pro-validation" element={<ProValidationPage />} />
          <Route path="/internal/logs" element={<AuditLogPage />} />
          <Route path="/cgu" element={<LegalPage kind="cgu" />} />
          <Route path="/confidentialite" element={<LegalPage kind="privacy" />} />
          <Route path="/aya-prive" element={<RequireAuth><Chat /></RequireAuth>} />

          <Route path="/choix" element={<SpaceChoicePage />} />
          <Route path="/pro" element={<RequireAuth><AyaProHomePage /></RequireAuth>} />
          <Route path="/pro/acces" element={<ProAccessPage />} />
          <Route path="/pro/fiscal" element={<RequireAuth><FiscalCenterPage /></RequireAuth>} />
          <Route path="/pro/categorie/:catId" element={<RequireAuth><ProCategoryPage /></RequireAuth>} />
          <Route path="/pro/assistant" element={<RequireAuth><ProAssistantPage /></RequireAuth>} />
          <Route path="/pro/compte" element={<RequireAuth><ProComptePage /></RequireAuth>} />
          <Route path="/pro/desk" element={<DeskPage />} />
          <Route path="/pro/taxes" element={<RequireAuth><ProTaxesPage /></RequireAuth>} />
          {/* v2.19.39-sec1 — Page de connexion dédiée (auth wall). */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/ops" element={<RequireAuth><OpsDashboard /></RequireAuth>} />
          <Route path="/ops-b2b" element={<RequireAuth><OpsB2bPage /></RequireAuth>} />
          {/* v2.19.26 — Page publique "Allumons la Côte d'Ivoire" (non-auth, mobile-first). */}
          <Route path="/carte-publique" element={<PublicCoverageMap />} />
          <Route path="/map-explorer" element={<RequireAuth><MapExplorerPage /></RequireAuth>} />
          <Route path="/addressing" element={<AddressingPage />} />
          {/* v2.5.0 : route publique pour utilisateurs finaux (non-livreurs) */}
          <Route path="/navigate" element={<DeliveryPage />} />
          {/* v2.5.0 : route livreur protégée par token statique par société */}
          <Route path="/civ-ai/gps" element={<GpsCourierPage />} />
          {/* Rétro-compat : /delivery redirige vers /navigate avec querystring */}
          <Route path="/delivery" element={<DeliveryRedirect />} />
          {/* v2.6.0 : Mon Compte — adresses sauvegardées + actions navigation */}
          <Route path="/mon-compte" element={<RequireAuth><MonComptePage /></RequireAuth>} />
          {/* v3.0.0-rc.8t : AYA Live — commerce en direct via QR overlay */}
          <Route path="/pro/live" element={<RequireAuth><LiveDashboardPage /></RequireAuth>} />
          <Route path="/pro/catalogues" element={<RequireAuth><MerchantCatalogsPage /></RequireAuth>} />
          {/* v3.7.2 : Salle Ops Live — salle de contrôle owner livreurs */}
          <Route path="/ops/live" element={<RequireAuth><OpsLiveRoomPage /></RequireAuth>} />
          <Route path="/live/overlay/:sessionId" element={<LiveOverlayPage />} />
          <Route path="/live/:merchantId" element={<LiveLandingPage />} />
          {/* v2.19.29 : Page publique d'atterrissage pour les invitations B2B */}
          <Route path="/inscription-pro" element={<ProOnboardingPage />} />

          <Route path="/pro/bienvenue" element={<AyaProStartPage />} />
          <Route path="/pro/inscription" element={<AyaProSignupPage />} />
          <Route path="/pro/connexion" element={<AyaProLoginPage />} />
          <Route path="/pro/activation/:token" element={<AyaProActivatePage />} />
          <Route path="/pro/dashboard" element={<AyaProDashboardPage />} />
          <Route path="/boutique/:slug" element={<BoutiquePage />} />
          <Route path="/personnalite/:slug" element={<PersonnalitePage />} />
          <Route path="/mairie/:slug" element={<MairiePage />} />
          {/* v2.19.30 : Dashboard owner pour valider les inscriptions partenaires */}
          <Route path="/ops/inscriptions-pro" element={<Navigate to="/internal/operations/pro-validation" replace />} />
          {/* v2.19.31 : Top fiches par impressions LLM (tracking actif en v2.19.32) */}
          <Route path="/ops/impressions" element={<RequireAuth><OpsImpressionsPage /></RequireAuth>} />
          {/* v2.19.33 : Digests WhatsApp mensuels pour les owners B2B */}
          <Route path="/ops/digests-mensuels" element={<RequireAuth><OpsDigestsPage /></RequireAuth>} />
          {/* v2.19.34 : Page partage d'une adresse nommée "Maison Koffi" */}
          <Route path="/a/:slugSuffix" element={<SharedAddressPage />} />
          {/* v2.19.35 : Marketplace dispatch livreurs */}
          <Route path="/ops/commandes" element={<RequireAuth><OpsCommandesPage /></RequireAuth>} />
          {/* v3.0.0-rc.8 : Console partenaires (Jumia/Sococé/etc) — import CSV catalogues */}
          <Route path="/ops-partners" element={<RequireAuth><PartnerConsolePage /></RequireAuth>} />
          <Route path="/track/:order_ref" element={<TrackOrderPage />} />
          {/* v3.17.1 — Panier Famille : page publique de paiement diaspora. */}
          <Route path="/panier-famille/:basketId" element={<FamilyBasketPage />} />
          {/* v3.18.0 — Espace Diaspora : vue du moteur unique de demandes. */}
          <Route path="/diaspora" element={<DiasporaDashboardPage />} />
          {/* v3.24.0 — Mini-site public d'un commerce Food/Beauté. */}
          <Route path="/place/:placeId" element={<MiniSitePage />} />
          <Route path="/media" element={<RequireAuth><MediaHubPage /></RequireAuth>} />
          {/* v4.4 — Kiosque + catalogues commerçants (deep links publics : WhatsApp, Instagram, QR…) */}
          <Route path="/kiosque" element={<RequireAuth><MediaHubPage /></RequireAuth>} />
          <Route path="/kiosque/catalogues" element={<KiosqueCatalogsPage />} />
          <Route path="/kiosque/section/:sectionId" element={<KiosqueSectionPage />} />
          <Route path="/kiosque/catalogue/:catalogId" element={<CatalogDetailPage />} />
          <Route path="/kiosque/merchant/:merchantId" element={<KiosqueCatalogsPage merchantMode />} />
          <Route path="/kiosque/product/:productId" element={<CatalogDetailPage productMode />} />
          {/* v2.19.36 : Replay timelapse MP4/WebM d'une livraison */}
          <Route path="/replay/:order_ref" element={<ReplayPage />} />
          {/* v2.19.37 : Page Arrivée livreur (preuve + photos enrichissement) */}
          <Route path="/courier/arrival/:order_ref" element={<RequireAuth><CourierArrivalPage /></RequireAuth>} />
          <Route path="/request/:token" element={<AddressRequestLandingPage />} />
          {/* v2.11.0 : page publique d'un event (QR code, WhatsApp, Réserver) */}
          <Route path="/event/:address_civ" element={<EventPublicPage />} />
          <Route path="/jobs/:id" element={<JobDetailPage />} />
          <Route path="/admin/:id" element={<DirectoryDetailPage kind="admin" />} />
          <Route path="/finance/:id" element={<DirectoryDetailPage kind="finance" />} />
          {/* v2.18.0 : route livreur PRO protégée par cookie + page de login dédiée */}
          <Route path="/livreur/login" element={<CourierLoginPage />} />
          <Route path="/livreur/navigate" element={<RequireAuth><CourierNavigatePage /></RequireAuth>} />
          <Route path="/livreur/historique" element={<RequireAuth><CourierHistoriquePage /></RequireAuth>} />
          <Route path="/livreur/zones-chaudes" element={<RequireAuth><CourierHeatmapPage /></RequireAuth>} />
          {/* v2.19.0 : page publique de recherche (alias /search). */}
          <Route path="/recherche" element={<SearchPage />} />
          <Route path="/search" element={<RequireAuth><SearchPage /></RequireAuth>} />
          <Route path="/multiservice" element={<RequireAuth><MultiservicePage /></RequireAuth>} />
          <Route path="/multiservice/historique" element={<RequireAuth><MultiserviceHistoryPage /></RequireAuth>} />
          <Route path="/enregistres" element={<SavedPage />} />
          <Route path="/fiche/:docId" element={<SearchDetailPage />} />
          <Route path="/cabinet/:slug" element={<CabinetPage />} />
          <Route path="/cabinet/:slug/dossier" element={<CabinetDossierPage />} />
          <Route path="/cabinet/:slug/visio/:apptId" element={<CabinetVisioPage />} />
          <Route path="/cabinet/:slug/admin" element={<CabinetAdminPage />} />
          <Route path="/founder-login" element={<FounderLoginPage />} />
          <Route path="/founder-onboarding" element={<FounderOnboardingPage />} />
          <Route path="/founder-partner" element={<FounderDashboardPage />} />
          <Route path="/verifier-recu" element={<VerifyReceiptPage />} />
          <Route path="/commerce" element={<RequireAuth><CommercePage /></RequireAuth>} />
          <Route path="/services" element={<RequireAuth><ServicesPage /></RequireAuth>} />
          <Route path="/bien-etre" element={<RequireAuth><BienEtrePage /></RequireAuth>} />
          <Route path="/pro/:id" element={<RequireAuth><ProProfilePage /></RequireAuth>} />
          <Route path="/location" element={<RequireAuth><LocationPage /></RequireAuth>} />
          <Route path="/bien/:id" element={<RequireAuth><BienDetailPage /></RequireAuth>} />
          <Route path="/transport-pro" element={<RequireAuth><TransportProPage /></RequireAuth>} />
          <Route path="/services-publics" element={<RequireAuth><ServicesPublicsPage /></RequireAuth>} />
          <Route path="/sante" element={<RequireAuth><SantePage /></RequireAuth>} />
          <Route path="/transport/avion" element={<FlightBookingPage />} />
          <Route path="/transport/car" element={<BusBookingPage />} />
          <Route path="/transport/taxi" element={<TaxiBookingPage />} />
          <Route path="/transport/chauffeur" element={<ChauffeurPrivePage />} />
          <Route path="/mes-billets" element={<MesBilletsPage />} />
          <Route path="/experiences" element={<ExperiencesPage />} />
          <Route path="/solidarite" element={<SolidaritePage />} />
          <Route path="/academy" element={<AcademyPage />} />
          <Route path="/transport" element={<RequireAuth><TransportHubPage /></RequireAuth>} />
          <Route path="/chauffeur" element={<ChauffeurPage />} />
          {/* v3.0.0-rc.4 — Phase 5.b.4 : Governance Dashboard (owner-only, role check côté page). */}
          <Route path="/governance" element={<RequireAuth><GovernancePage /></RequireAuth>} />
          {/* v3.0.0-rc.7-phaseCD — Phase C.2 : Wallet B2C utilisateur final. */}
          <Route path="/wallet" element={<RequireAuth><WalletB2cPage /></RequireAuth>} />
          {/* [SPRINT J P1] Page commerçant dédiée (public, mock data). */}
          <Route path="/commercant/:slug" element={<MiniSitePage />} />
          {/* [SPRINT K P1] Services prestataires (mock). Landing + category supprimés (Option B chips swap). */}
          <Route path="/services/provider/:slug" element={<ServiceProviderPage />} />
          <Route path="/rx/preview" element={<Suspense fallback={<div style={{padding:24}}>Chargement RX Preview…</div>}><RXPreviewPage /></Suspense>} />
        </Routes>
      </BrowserRouter>
    </div>
    </AyaToastProvider>
    </LazyMotion>
  );
}

export default App;
